import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

type AddressProps = {
  tabAccess: boolean;
  isExpandedAddress: boolean;
  isManualAddress: boolean;
};

export const AddressWrapper = styled("div")(
  ({ tabAccess, isExpandedAddress, isManualAddress }: AddressProps) => ({
    borderBottom: tabAccess && isExpandedAddress ? "1px solid #ccdeee" : "",
    paddingBottom: isManualAddress ? 20 : 0,
    marginBottom: 24,
  })
);

const styles = makeStyles(() => ({
  addressInfoBorder: {
    borderBottom: "1px solid #CCDEEE",
  },
  hr: {
    margin: "25px 0 20px 0",
  },
  onboardingBlueLabel: {
    color: "#0055A4 !important",
    fontWeight: 600,
  },
}));

export default styles;
